import { STYLE_ORDER, STYLES } from '../../data/styles';
import { Scores } from '../../types';

interface ScoreBreakdownProps {
  scores: Scores;
}

export function ScoreBreakdown({ scores }: ScoreBreakdownProps) {
  const total = Object.values(scores).reduce((a, b) => a + b, 0);
  const sorted = [...STYLE_ORDER].sort((a, b) => scores[b] - scores[a]);

  return (
    <div className="bg-white rounded-xl border border-cream/40 shadow-sm p-6">
      <h3 className="text-sm font-semibold uppercase tracking-widest text-brand-slate mb-4">
        Score breakdown
      </h3>
      <div className="space-y-3">
        {sorted.map((key) => {
          const style = STYLES[key];
          const pct = total > 0 ? Math.round((scores[key] / total) * 100) : 0;
          return (
            <div key={key}>
              <div className="flex justify-between text-sm mb-1">
                <span className="font-medium text-brand">{style.name}</span>
                <span className="text-brand-slate">
                  {scores[key]} / {total}
                </span>
              </div>
              <div className="w-full bg-cream/20 rounded-full h-2.5">
                <div
                  className="h-2.5 rounded-full transition-all duration-700"
                  style={{ width: `${pct}%`, backgroundColor: style.color }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
